import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ViewRef, OnDestroy } from '@angular/core';
import { LifeStyleQuestion, rangeData, ErrorMsgModel } from 'src/app/pages/medical-underwriting/model';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Tooltip } from 'src/app/model/tooltip';
import { SyncService } from '../../pages/medical-underwriting/services/sync.service';
import { UtilityServiceForMedicalService } from 'src/app/pages/medical-underwriting/services/utility-service';
import { DigitsModal, AccordQuestionStoreModel } from 'src/app/pages/medical-underwriting/model/mcUserJourney.model';
import { ASSETPATH } from 'src/app/constants/application-const';
import { Subscription } from 'rxjs';
import { UtilService } from 'src/app/shared';
import { AlertModal } from 'src/app/model/alert';
import { ActivatedRoute } from '@angular/router';
import { OnlyNumberDirective } from '../../pages/medical-underwriting/directives/custom-onlyNumber-directive';
import { ModalComponent } from '../modal/modal.component';
import { ToolTipNotificationComponent } from '../../form-elements/tool-tip-notification/tool-tip-notification.component';
import { NgClass } from '@angular/common';
import { ModalMeicalUnderwritingComponent } from '../modal-meical-underwriting/modal-meical-underwriting.component';

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
  imports: [ReactiveFormsModule, ToolTipNotificationComponent, ModalComponent, NgClass]
})
export class InputComponent implements OnInit, OnDestroy {

  @Input() question: LifeStyleQuestion;
  @Input() parent: UntypedFormGroup;
  controlName: string;
  @Input() indexToAppend: number;
  @Input() accordIndexToAppend: number;
  @Output() textChangeEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Input() objToReferForAccord: AccordQuestionStoreModel;
  @Input() errorValue: ErrorMsgModel[];
  @Input() toggleBtnFlag: boolean = false;
  domId: string;
  selectedValue: string;
  enableDecimalInput: boolean;
  private rangeValidationData: rangeData[];
  numberOfDigit: string;
  public rangeModalObject: DigitsModal;
  public imagePath: string;
  subscription: Subscription;
  businessValidationSubs: Subscription;
  public tooltipModalConfig: AlertModal;
  tooltipModal;
  displayTooltipAlert: boolean = false;

  constructor(private fb: UntypedFormBuilder, private cdRef: ChangeDetectorRef, private utilService: UtilService, private syncService: SyncService, private utilityServiceForMedicalService: UtilityServiceForMedicalService,
    private activatedRoute: ActivatedRoute) {
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
  }

  ngOnInit() {
    this.domId = this.utilityServiceForMedicalService.getDomId(this.question.id, this.accordIndexToAppend, this.indexToAppend);
    this.controlName = this.utilityServiceForMedicalService.getControlName(this.question.id, this.accordIndexToAppend);
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    this.rangeModalObject = null;
    if (this.objToReferForAccord) {
      this.question.responseValueByUser = this.utilityServiceForMedicalService.getResponseValueFromRefObj(this.objToReferForAccord, this.question.id, this.accordIndexToAppend);
    }
    if (this.question.controlStyle === 'InputBox_image_3number') {
      this.imagePath = ASSETPATH.images + this.question.id + ASSETPATH.png;
    }
    this.selectedValue = this.question.responseValueByUser ? this.question.responseValueByUser : "";
    this.syncService.getRangeValidationJson().subscribe((res) => {
      this.rangeValidationData = res;
      this.selectedValue = this.question.responseValueByUser ? this.question.responseValueByUser : "";
      this.setValueForInputBox(this.question, this.selectedValue);
      this.checkRange(this.rangeValidationData);
    });

    if(this.parent.controls[this.controlName]){
      this.businessValidationSubs = this.syncService.businessValidationEvent.subscribe((res)=>{
        this.setValueToFrom(true);
      });
    }

    this.subscription = this.utilService.emitInput.subscribe(val => {
      if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
        this.cdRef.detectChanges();
      }
    });

  }

  ngOnDestroy(): void {
    if (this.parent.get(this.controlName)) {
      this.parent.get(this.controlName).markAsUntouched();
    }
    if(this.businessValidationSubs){
      this.businessValidationSubs.unsubscribe();
    }
  }



  setValueForInputBox(question: LifeStyleQuestion, selectedValue: string) {

    if (this.parent.controls[this.controlName]) {
      this.parent.controls[this.controlName].setValue(selectedValue);
    }
    else {
      this.parent.addControl(this.controlName, this.fb.control(null, question.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
      this.parent.controls[this.controlName].setValue(selectedValue);
    }
    if (!this.toggleBtnFlag) {
      this.checkRangeValidation();
    }
  }

  checkRangeValidation() {
    if (this.parent.controls[this.controlName]) {
      if (this.rangeModalObject && this.rangeModalObject.minValue) {
        if (this.parent.controls[this.controlName].value && this.parent.controls[this.controlName].value.charAt(this.parent.controls[this.controlName].value.length-1) === '.') {
          this.parent.controls[this.controlName].setErrors({ invalid: true });
        } else {
          this.parent.controls[this.controlName].setErrors(null);
          this.parent.controls[this.controlName].setValidators(Validators.compose(
            [this.question.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null,
            Validators.min(+this.rangeModalObject.minValue)]));
          this.parent.controls[this.controlName].updateValueAndValidity({ onlySelf: true });
        }
      }
    }
  }

  setValueToFrom(isCalledFromBusinessValidationSubs: boolean) {
    this.setValueForInputBox(this.question, this.selectedValue);
    this.textChangeEventEmitter.emit({ errorValue: this.errorValue, isCalledFromBusinessValidationSubs: isCalledFromBusinessValidationSubs });
  }

  setValueToFormOnBlur(){
    this.question.responseValueByUser = this.selectedValue;
    this.setValueForInputBox(this.question, this.selectedValue);
    this.textChangeEventEmitter.emit({ errorValue: this.errorValue, isCalledFromBusinessValidationSubs: false });
  }

  initializeToolTipDateComp(questionObj: LifeStyleQuestion): Tooltip {
    return new Tooltip(questionObj.helpText, '', false);
  }

  checkRange(rangeValidationData: rangeData[]) {
    let temp = this.question.responseRange.toString().split("=");
    let newResponseFromJson = temp[1];

    if (newResponseFromJson) {
      this.rangeValidationData.forEach(range => {
        if (newResponseFromJson === range.valueKey) {
          this.rangeModalObject = new DigitsModal();
          this.rangeModalObject.minValue = range.valueMin;
          this.rangeModalObject.maxValue = range.valueMax;
          this.rangeModalObject.valueKey = range.valueKey;
          this.rangeModalObject.decimalRange = (range.valueMax.indexOf('.') > -1 ? true : false);
        }
      });
    }
  }

  displayDrpTooltipMessage(question){
    this.tooltipModal.content = question.helpText;
    this.displayTooltipAlert = true;
  }

  alertTooltipPrimaryBtnClick() {
		this.closeModal();
	}

	closeModal() {
		this.displayTooltipAlert = false;
	}

}


